module.exports = (__webpack_require__(8))(8);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/router.js from dll-reference girder_lib
// module id = 351
// module chunks = 0